// extracted by mini-css-extract-plugin
export default {"price":"Price_price__klDw2","label":"Price_label__AIjkh"};